import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Header from 'components/headers/addLoan'
import HandIcon from 'assets/images/easyPay/init.svg'
import useSetInitPayment from './hooks/useSetInitPayment'
import DotsLoading from 'components/loadings/dotsLoading'
import style from './payForOther.module.scss'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import AddJustPayForOtherModal from 'components/modals/addJustPayForOthers'
import EditIcon from 'assets/images/loans/edit.svg'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import { NumericFormat } from 'react-number-format'
import Switch from 'react-switch'
import useSetTransactionsWallet from './hooks/useSetTransactionsWallet'
import useGetMoneyPoolCashin from './hooks/useGetMoneyPoolCashin'
import {
    ISelectedBank,
    useIsDefaultGateway,
} from 'utilities/hooks/useIsDefaultGateway'

export default function PayForOther() {
    const { state } = useLocation()
    const initialUnpaid = Number(state?.item?.unpaid_portion)

    const {
        data: initData,
        isLoading,
        refetchWithAmount,
    } = useSetInitPayment(Number(state?.item?.id), initialUnpaid)
    const [lackOfWallet, setLackOfWallet] = useState<number>(0)
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const [payment, setPayment] = useState<number>(initialUnpaid)
    // useEffect(() => {
    //     if (initData && !isOpenPayment) {
    //         setPayment(Number(state?.item?.unpaid_portion))
    //     }
    // }, [initData])
    useEffect(() => {
        if (state?.item?.unpaid_portion) {
            setPayment(Number(state.item.unpaid_portion))
        }
    }, [])
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { moneyPool } = useParams()

    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data: walletData } = useGetInitPaymentOs(
        profile?.id,
        Number(initData?.commission),
        Number(payment)
    )

    const [jsonData, setJsonData] = useState<any>([])
    const [isSelected, setIsSelected] = useState<ISelectedBank>({
        saderat: false,
        parsian: false,
    })

    useIsDefaultGateway(initData, setIsSelected)

    useEffect(() => {
        if (payment && moneyPool && initData && state) {
            setJsonData([
                {
                    moneyPool: Number(moneyPool),
                    amount: Number(payment) + Number(initData.commission),
                    ctxId: Number(moneyPool),
                    gateway: isSelected.saderat ? 5 : 9,
                    receiver: state?.item?.member?.id,
                    poolShip: state?.item?.id,
                    trustState: state.trustState,
                    commission: Number(initData.commission),
                    source: 'hwt',
                },
            ])
        }
    }, [payment, moneyPool, initData, state, lackOfWallet])
    const { mutate } = useGetMoneyPoolCashin(jsonData)
    const { mutateTransactionWallet: mutateWalletPay } =
        useSetTransactionsWallet(jsonData)

    useEffect(() => {
        if (initData && payment) {
            if (isWallet) {
                if (Number(walletData?.wallet_balance) >= Number(payment)) {
                    setLackOfWallet(0)
                }
                if (Number(walletData?.wallet_balance) < Number(payment)) {
                    setLackOfWallet(
                        Number(payment) +
                            Number(initData.commission) -
                            Number(walletData?.wallet_balance)
                    )
                }
            } else {
                setLackOfWallet(Number(payment) + Number(initData.commission))
            }
        }
    }, [initData, payment, isWallet])
    const navigate = useNavigate()
    const { mutateTransactionWallet } = useSetTransactionsWallet(jsonData)

    return (
        <>
            <div className=" h-screen relative">
                <Header title="" />
                <div className="">
                    {initData && state && !isLoading ? (
                        <>
                            <div className=" relative">
                                <img
                                    src={HandIcon}
                                    alt="hand"
                                    className=" mx-auto absolute -top-16 z-50 right-32"
                                />

                                <div className={style['StyledReceipt']}>
                                    <div>
                                        <p>واریز به:</p>
                                        <p>همیان</p>
                                        <hr className=" mt-2" />
                                    </div>
                                    <div className=" flex justify-between mt-1">
                                        <p className="">مبلغ:</p>
                                        <div className={classNames('flex')}>
                                            {isOpenPayment ? (
                                                <NumericFormat
                                                    thousandSeparator
                                                    allowNegative={false}
                                                    name="totalObligationManager"
                                                    className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                    value={
                                                        payment
                                                            ? payment
                                                            : undefined
                                                    }
                                                    onValueChange={(values) => {
                                                        const { value } = values

                                                        setPayment(
                                                            Number(value)
                                                        )
                                                    }}
                                                />
                                            ) : (
                                                // <input
                                                //     type="number"
                                                //     min={0}
                                                //     className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                //     value={
                                                //         payment
                                                //             ? payment
                                                //             : undefined
                                                //     }
                                                //     onChange={(e) =>
                                                //         setPayment(
                                                //             Number(
                                                //                 e.target.value
                                                //             )
                                                //         )
                                                //     }
                                                // />
                                                <p>
                                                    {payment
                                                        ? Number(
                                                              payment
                                                          ).toLocaleString()
                                                        : state?.item
                                                              ?.unpaid_portion &&
                                                          state?.item?.unpaid_portion.toLocaleString()}{' '}
                                                    تومان
                                                </p>
                                            )}
                                            {isOpenPayment ? (
                                                <p
                                                    onClick={async () => {
                                                        const updated =
                                                            await refetchWithAmount(
                                                                payment
                                                            )
                                                        if (updated) {
                                                            setPayment(
                                                                updated.amount
                                                            )
                                                        }
                                                        setIsOpenPayment(false)
                                                    }}
                                                    className=" text-sm text-green-1 mr-2"
                                                >
                                                    اعمال
                                                </p>
                                            ) : (
                                                <img
                                                    src={EditIcon}
                                                    alt="edit"
                                                    className=" w-4 mr-2"
                                                    onClick={() =>
                                                        setIsOpenPayment(true)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">هزینه اشتراک:</p>
                                        <p>
                                            {Number(
                                                initData.commission
                                            ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className=""> بابت:</p>
                                        <p>پرداخت حق عضویت</p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">نام صندوق:</p>
                                        <p>{state?.name}</p>
                                    </div>
                                    <div className=" flex justify-between mt-4">
                                        <div className="text-sm">
                                            <p>استفاده از کیف پول:</p>
                                            <p className=" text-text-gray">
                                                {walletData &&
                                                    walletData?.wallet_balance &&
                                                    walletData?.wallet_balance.toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <Switch
                                            onChange={() =>
                                                setIsWallet(!isWallet)
                                            }
                                            checked={isWallet}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <hr className=" my-4" />
                                    <div className=" flex justify-between mt-2">
                                        <p className="">مبلغ قابل پرداخت:</p>
                                        <p>
                                            {isWallet
                                                ? Number(
                                                      lackOfWallet
                                                  ).toLocaleString()
                                                : Number(
                                                      payment +
                                                          initData.commission
                                                  ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                </div>
                                <div className=" w-full items-center text-center my-4">
                                    <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                        <img
                                            src={
                                                initData?.gateways &&
                                                initData?.gateways[0]?.img_url
                                            }
                                            hidden={
                                                !initData?.gateways[0]
                                                    ?.is_active
                                            }
                                            alt="bank"
                                            className={classNames(
                                                'mx-2 cursor-pointer',
                                                !isSelected.saderat
                                                    ? ' border-1 border-gray-4 rounded-md'
                                                    : 'border-2 border-green-1 rounded-md'
                                            )}
                                            onClick={() =>
                                                setIsSelected({
                                                    saderat: false,
                                                    parsian: true,
                                                })
                                            }
                                        />
                                        <img
                                            src={
                                                initData?.gateways &&
                                                initData?.gateways[1]?.img_url
                                            }
                                            hidden={
                                                !initData?.gateways[1]
                                                    ?.is_active
                                            }
                                            alt="bank"
                                            className={classNames(
                                                'mx-2 cursor-pointer',
                                                !isSelected.parsian
                                                    ? ' border-1 border-gray-4 rounded-md'
                                                    : 'border-2 border-green-1 rounded-md'
                                            )}
                                            onClick={() =>
                                                setIsSelected({
                                                    saderat: true,
                                                    parsian: false,
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" bottom-10 absolute w-full">
                                <div className=" w-full">
                                    <div
                                        className=" mx-8 rounded-2xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                                        onClick={() => {
                                            if (initData) {
                                                if (
                                                    isSelected.saderat ||
                                                    isSelected.parsian
                                                ) {
                                                    if (isWallet) {
                                                        if (
                                                            lackOfWallet === 0
                                                        ) {
                                                            const payload: IPaymentData =
                                                                {
                                                                    amount:
                                                                        Number(
                                                                            payment
                                                                        ) +
                                                                        Number(
                                                                            initData.commission
                                                                        ),
                                                                    poolship:
                                                                        initData
                                                                            ?.receivers?.[0]
                                                                            ?.id,
                                                                    tag: '',
                                                                    transaction:
                                                                        {
                                                                            ctx_id: Number(
                                                                                moneyPool
                                                                            ),
                                                                            ctx_type:
                                                                                'mnp',
                                                                            destination:
                                                                                initData
                                                                                    ?.receivers?.[0]
                                                                                    ?.destination,
                                                                            is_group_pay:
                                                                                false,
                                                                            payer_name:
                                                                                '',
                                                                            receiver:
                                                                                initData
                                                                                    ?.receivers?.[0]
                                                                                    ?.id,
                                                                            receiver_name:
                                                                                '',
                                                                            source: 'hwt',
                                                                            state: '',
                                                                            state_time:
                                                                                '',
                                                                            transaction_code:
                                                                                '',
                                                                        },
                                                                    type: 'cnp',
                                                                }

                                                            mutateWalletPay(
                                                                //@ts-ignore
                                                                payload
                                                            )
                                                        } else {
                                                            const payload: IGatewayPaymentPayload =
                                                                {
                                                                    paymentItems:
                                                                        [
                                                                            {
                                                                                itemAmount:
                                                                                    Number(
                                                                                        payment
                                                                                    ),
                                                                                itemType:
                                                                                    initData
                                                                                        ?.receivers?.[0]
                                                                                        ?.type,
                                                                                itemId: state
                                                                                    ?.item
                                                                                    ?.id,
                                                                                box_id: Number(
                                                                                    moneyPool
                                                                                ),
                                                                                commission:
                                                                                    initData
                                                                                        ?.receivers?.[0]
                                                                                        ?.commission,
                                                                                description:
                                                                                    'پرداخت حق عضویت',
                                                                            },
                                                                        ],
                                                                    gateway: {
                                                                        uniqueCode:
                                                                            'HAM_IPG',
                                                                    },
                                                                    clientType:
                                                                        'pwa',
                                                                    use_wallet:
                                                                        true,
                                                                }
                                                            mutate(payload)
                                                        }
                                                    } else {
                                                        const payload: IGatewayPaymentPayload =
                                                            {
                                                                paymentItems: [
                                                                    {
                                                                        itemAmount:
                                                                            Number(
                                                                                payment
                                                                            ),
                                                                        itemType:
                                                                            initData
                                                                                ?.receivers?.[0]
                                                                                ?.type,
                                                                        itemId: state
                                                                            ?.item
                                                                            ?.id,
                                                                        box_id: Number(
                                                                            moneyPool
                                                                        ),
                                                                        commission:
                                                                            initData
                                                                                ?.receivers?.[0]
                                                                                ?.commission,
                                                                        description:
                                                                            'پرداخت حق عضویت',
                                                                    },
                                                                ],
                                                                gateway: {
                                                                    uniqueCode:
                                                                        'HAM_IPG',
                                                                },
                                                                clientType:
                                                                    'pwa',
                                                                use_wallet:
                                                                    false,
                                                            }
                                                        mutate(payload)
                                                    }
                                                } else {
                                                    toast.error(
                                                        'نوع درگاه پرداخت را انتخاب کنید'
                                                    )
                                                }
                                            }
                                        }}
                                    >
                                        پرداخت آنلاین
                                    </div>
                                </div>
                                {state?.isManager && (
                                    <div className=" w-full">
                                        <div
                                            className=" mx-8 rounded-2xl border-1 border-green-1  bg-white text-green-1 text-center py-3 my-2 cursor-pointer"
                                            onClick={() => {
                                                if (initData) {
                                                    if (
                                                        isSelected.saderat ||
                                                        isSelected.parsian
                                                    ) {
                                                        setIsOpen(true)
                                                    } else {
                                                        toast.error(
                                                            'نوع درگاه پرداخت را انتخاب کنید'
                                                        )
                                                    }
                                                }
                                            }}
                                        >
                                            ثبت پرداخت
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddJustPayForOtherModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
            />
        </>
    )
}
